import './AppTile.scss';

export default function AppTileSkeleton() {

  return (
      <div className={'app-tile block border loading'}>
      </div>
  );
}